/**
 * Image with text — "collection" type banner placement.
 *
 * The banner renders as its own Shopify section directly AFTER
 * main-collection-product-grid, so by default it stacks full-width below
 * the collection grid. With the Quick Customization panel present the
 * grid becomes a 2-col layout ([ QC sidebar | products ]), and a
 * full-width banner below it visually sits under the LEFT (sidebar)
 * column — not under the products.
 *
 * The QC layout wraps the products into `.collection-grid-section__content`
 * (column 2 of the grid, built at runtime by
 * team-design.banner-swatches.js → relocatePanelIntoGrid). We move the
 * banner into that content column as its last child so it flows directly
 * UNDER the product grid + pagination, inheriting the products' exact
 * column position and width. Mirrors the sidebar relocate pattern.
 *
 * No-ops safely when the content column doesn't exist (a collection
 * without a QC panel) — the banner just stays full-width below the grid.
 */
(function () {
  'use strict';

  function placeBanner() {
    var banners = document.querySelectorAll('.iwt-root--collection');
    if (!banners.length) return;

    // Products column (col 2). Built by banner-swatches.js, which runs
    // earlier in the defer chain, so it normally exists by the time this
    // script executes.
    var content =
      document.querySelector('.collection-grid-section.has-qc-panel > .collection-grid-section__content') ||
      document.querySelector('.collection-grid-section__content');

    // No QC content column (no panel / not built yet) — leave the banner
    // where it is (full-width below the grid).
    if (!content) return;

    for (var i = 0; i < banners.length; i++) {
      if (banners[i].parentNode !== content) content.appendChild(banners[i]);
    }

    // Theme-editor section re-renders can leave a stale copy behind — keep
    // only the last banner in the column.
    var dups = content.querySelectorAll(':scope > .iwt-root--collection');
    for (var j = 0; j < dups.length - 1; j++) {
      if (dups[j].parentNode) dups[j].parentNode.removeChild(dups[j]);
    }
  }

  placeBanner();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBanner);
  }
  // Safety net for defer-ordering / late layout building of the column.
  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(placeBanner);
  }
  // Re-run when the theme editor reloads a section (guard against binding
  // the document-level listener more than once).
  if (!window.__iwtCollectionPlacementBound) {
    window.__iwtCollectionPlacementBound = true;
    document.addEventListener('shopify:section:load', placeBanner);
  }
})();
